<template>
  <div class="clients">
    <Navigation />
    <v-main>
      <v-container fluid fill-height>
        <v-layout v-resize="onResize">
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <v-row class="pb-4 text-center" align="center">
                  <v-col cols="12" md="auto">
                    <h2 class="ml-2 headline">Liste des clients</h2>
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="12" md="auto">
                    <v-text-field
                      v-model="search"
                      clearable
                      hide-details
                      solo-inverted
                      flat
                      prepend-inner-icon="search"
                      label="Rechercher"
                      @input="refreshPagination"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>

                  <v-col cols="12" md="auto">
                    <!-- CREATE/EDIT DIALOG -->
                    <v-dialog
                      v-model="dialogEdit"
                      max-width="1400px"
                      persistent
                      scrollable
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          @click.stop="createItem"
                          >Nouveau client</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title class="primary white--text">
                          <template v-if="action == 'create'"
                            >Création</template
                          >
                          <template v-if="action == 'update'"
                            >Modification</template
                          >
                          d'un client
                          <v-spacer></v-spacer>
                          <v-btn small text dark @click="dialogEdit = false"
                            >Annuler</v-btn
                          >
                        </v-card-title>
                        <v-card-text>
                          <ClientForm
                            ref="ClientForm"
                            v-model="editedClient"
                            :action="action"
                            :key="currentClientKey"
                            @savedForm="handleSavedClientForm"
                            @canceledForm="handleCanceledClientForm"
                          />
                        </v-card-text>
                      </v-card>
                    </v-dialog>

                    <!-- SHOW DIALOG -->
                    <v-dialog v-model="dialogShow" ref="dialog" scrollable>
                      <v-card>
                        <v-card-title class="primary py-0">
                          <v-row class="subtitle-2 align-center white--text">
                            <v-col
                              cols="auto"
                              @click="dialogShow = false"
                              class="cursor-pointer"
                              >Liste des clients</v-col
                            >
                            >
                            <v-col cols="auto">{{ shownClient.name }}</v-col>
                            <v-spacer></v-spacer>
                            <v-btn small text dark @click="dialogShow = false"
                              >Fermer</v-btn
                            >
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <Client
                            ref="Client"
                            v-model="shownClient"
                            @closeDialogShow="dialogShow = false"
                          />
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="secondary"
                            text
                            @click="dialogShow = false"
                            >Fermer</v-btn
                          >
                          <v-btn color="primary" @click="editItem(shownClient)"
                            >Modifier</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>

                <v-data-table
                  :items="clients"
                  :options.sync="pagination"
                  :items-per-page="rowsPerPageItems"
                  :server-items-length="total"
                  :loading="loading"
                  :headers="headers"
                  :class="{ mobile: isMobile }"
                  :footer-props="{
                    itemsPerPageText: 'Ligne par page',
                  }"
                >
                  <template v-slot:item="props">
                    <tr @click.stop="showItem(props.item)">
                      <td data-label="Nom">{{ props.item.name }}</td>
                      <td class="text-right">
                        <v-icon
                          small
                          class="mr-2"
                          title="Voir"
                          @click.stop="showItem(props.item)"
                          >remove_red_eye</v-icon
                        >
                        <v-icon
                          small
                          class="mr-2"
                          @click.stop="editItem(props.item)"
                          title="Editer"
                          >edit</v-icon
                        >
                        <v-icon small @click.stop="deleteItem(props.item)" title="Supprimer"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-data> Aucun client </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import ClientForm from "../components/ClientForm";
import Client from "../components/Client";

export default {
  components: {
    ClientForm,
    Client,
  },
  data() {
    return {
      ready: false,
      clients: [],
      allClients: undefined,
      action: "create",
      currentClientKey: 0,
      shownClient: {},
      editedClient: {},
      defaultClient: {
        name: "",
        description: "",
        phone: "",
        logo: null,
        logo_url: "",
      },
      pagination: {
        page: 1,
      },
      search: "",
      total: 0,
      rowsPerPageItems: 10,
      headers: [
        {
          text: "Nom",
          align: "left",
          value: "name",
        },
        {
          text: "",
          value: "",
          sortable: false,
        },
      ],
      dialogEdit: false,
      dialogShow: false,
      isMobile: false,
      loading: false,
    };
  },
  mounted() {
    //
  },
  methods: {
    onResize() {
      this.isMobile = this.$vuetify.breakpoint.smAndDown;
    },
    getClients(queries) {
      if (!this.allClients) {
        this.$store
          .dispatch("clientsRequest", queries)
          .then((result) => {
            this.allClients = result.data;
            this.total = this.allClients.length;
            this.clients = result.data;
            const start =
              (this.pagination.page - 1) * this.pagination.itemsPerPage;
            let end = Math.min(
              this.clients.length,
              this.pagination.page * this.pagination.itemsPerPage
            );
            if (this.pagination.itemsPerPage == -1) {
              end = this.clients.length + 1;
            }
            this.clients = this.clients.slice(start, end);

            this.loading = false;
            if (!this.ready)
              this.$checkHistory("client", (client) => this.showItem(client));
            this.ready = true;
          })
          .catch(() => {
            //
          });
      } else {
        if (this.search) {
          this.clients = this.allClients.filter((client) =>
            client.name.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').includes(this.search.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''))
          );
        } else {
          this.clients = this.allClients;
        }
        this.total = this.clients.length;
        const start = (this.pagination.page - 1) * this.pagination.itemsPerPage;
        let end = Math.min(
          this.clients.length,
          this.pagination.page * this.pagination.itemsPerPage
        );
        if (this.pagination.itemsPerPage == -1) {
          end = this.clients.length + 1;
        }
        this.clients = this.clients.slice(start, end);

        this.loading = false;
        if (!this.ready)
          this.$checkHistory("client", (client) => this.showItem(client));
        this.ready = true;
      }
    },
    handleSavedClientForm(client) {
      this.shownClient = client;
      this.refreshPagination();
      this.dialogEdit = false;
    },
    handleCanceledClientForm() {
      this.dialogEdit = false;
    },
    showItem(client) {
      // console.log('clients showItem', client)
      this.shownClient = client;
      this.dialogShow = true;
    },
    createItem() {
      this.action = "create";
      this.editedClient = Object.assign({}, this.defaultClient);
      this.dialogEdit = true;
    },
    editItem(client) {
      this.action = "update";
      this.editedClient = Object.assign({}, client);
      this.dialogEdit = true;
    },
    deleteItem(client) {
      if (confirm("Êtes-vous sûr de vouloir supprimer ce client ?")) {
        this.$store
          .dispatch("clientDeleteRequest", { id: client.id })
          .then((result) => {
            this.$store.commit("setSnack", {
              type: "success",
              msg: "Client supprimé !",
            });
            this.refreshPagination();
          })
          .catch((err) => {
            this.$store.commit("setSnack", {
              type: "red",
              msg: err.response.data,
            });
          });
      }
    },
    refreshPagination() {
      const queries = {
        // page: this.pagination.page,
        // per_page: this.pagination.itemsPerPage,
        sort: this.pagination.sortBy,
        direction: this.pagination.sortDesc[0] ? "desc" : "asc",
        // search: this.search,
      };

      this.loading = true;
      this.getClients(queries);
    },
  },
  watch: {
    pagination: {
      handler() {
        this.refreshPagination();
      },
      deep: true,
    },
    dialogShow() {
      if (this.dialogShow) {
        this.$clicked_client = this.shownClient;
      } else this.$clicked_client = null;

      if (this.dialogShow) this.$resetDialogScroll();

      this.currentClientKey += 1;
    },
    dialogEdit() {
      if (this.dialogEdit) this.$resetDialogScroll();

      this.currentClientKey += 1;
    },
  },
};
</script>
